var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "86.25px",
    height: "116.75px",
    viewBox: "83 12.25 86.25 116.75",
    enableBackground: "new 83 12.25 86.25 116.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bold",
    d: "M153.408,68.857c11.09-13.064,9.488-32.646-3.576-43.734c-5.617-4.768-12.746-7.381-20.113-7.373 c-0.615,0-1.242,0.036-1.867,0.071c-0.123-0.01-0.227-0.071-0.352-0.071H92c-2.451,0-4.438,1.987-4.438,4.438v4.438 c0,2.451,1.987,4.438,4.438,4.438h4.438v79.875H92c-2.451,0-4.438,1.986-4.438,4.438v4.438c0,2.451,1.987,4.438,4.438,4.438h39.938 c0.148-0.021,0.295-0.051,0.439-0.089c0.594,0.032,1.188,0.089,1.779,0.089c17.139,0.018,31.045-13.862,31.063-31 C165.229,83.738,160.875,74.748,153.408,68.857z M114.188,35.5h15.531c7.352,0,13.313,5.96,13.313,13.313 s-5.961,13.313-13.313,13.313h-15.531V35.5z M134.156,106.5h-19.969V79.875h19.969c7.352,0,13.313,5.961,13.313,13.313 S141.508,106.5,134.156,106.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.68682b24bb953efd5d921eea8cf7a981.svg";
export { ForwardRef as ReactComponent };